import { render, staticRenderFns } from "./EventListingElement.vue?vue&type=template&id=38f10395&"
import script from "./EventListingElement.vue?vue&type=script&lang=js&"
export * from "./EventListingElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports